function initializeSlickSlidersProductItem() {
  $(".product-item").each(function () {
    var $productItem = $(this);
    var $slider = $productItem.find(".product-slide__slider");
    var $productImage = $productItem.find(".product-image");
    var $productSlide = $productItem.find(".product-slide");
    var $productContainer = $productItem.find(".product-slider");

    if ($slider.hasClass("slick-initialized")) {
      return;
    }

    var slideCount = $slider.children().length;

    if (slideCount > 1) {

      $productSlide.addClass("produt-item-hidden");

      $slider.on("init", function () {
        $productSlide.removeClass("produt-item-hidden");
        $slider.css("opacity", "1");
        $productContainer.removeClass("produt-item-hidden");
      });

      $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        dots: true,
        arrows: true,
        infinite: false,
      });

    } else {
      $productContainer.removeClass("produt-item-hidden");
      $productImage.find("img").removeClass("product-imagen-hidden");
    }
  });
}


$(document).ready(function () {
  initializeSlickSlidersProductItem();
});
